<template>
  <div>
    <div class="flex" style="margin-top: 13px; margin-bottom: 20px">
      <div>
        <div
          style="margin: 0 auto; width: 100px"
          :class="achType === '论文' ? 'selectAchievementTitle' : 'achievementTitle'"
          @click="changeAchType('论文')"
        >
          论文({{ paperData.paperElements }})
        </div>
        <div v-if="achType === '论文'" style="border-bottom: 2px solid #1241C9"></div>
      </div>
      <div v-if="patentData.patentElements">
        <div
          style="margin: 0 auto; width: 100px"
          :class="achType === '专利' ? 'selectAchievementTitle' : 'achievementTitle'"
          @click="changeAchType('专利')"
        >
          专利({{ patentData.patentElements }})
        </div>
        <div v-if="achType === '专利'" style="border-bottom: 2px solid #1241C9"></div>
      </div>
      <div v-if="projectData.projectElements">
        <div
          style="margin: 0 auto; width: 100px"
          :class="achType === '项目' ? 'selectAchievementTitle' : 'achievementTitle'"
          @click="changeAchType('项目')"
        >
          项目({{ projectData.projectElements }})
        </div>
        <div v-if="achType === '项目'" style="border-bottom: 2px solid #1241C9"></div>
      </div>
    </div>

    <div v-if="achType === '论文'" v-loading="paperLoading" style="min-height: 400px">
      <div class="text-left" style="margin-bottom: 20px; color: rgba(218, 10, 10, 0.7)">
        注：该作者共发表论文{{ paperData.paperElements }}篇；其中第一作者论文数为{{
          paperData.paperAuthor || 0
        }}篇；
        <span v-if="paperData.paperLeadAndVenueVO">
          <span v-if="paperData.paperLeadAndVenueVO?.nature && paperData.paperLeadAndVenueVO?.nature !== 0">发表Nature{{ paperData.paperLeadAndVenueVO?.nature }}篇；</span>
          <span v-if="paperData.paperLeadAndVenueVO?.science && paperData.paperLeadAndVenueVO?.science !== 0">发表Science{{ paperData.paperLeadAndVenueVO?.science }}篇；</span>
          <span v-if="paperData.paperLeadAndVenueVO?.cell && paperData.paperLeadAndVenueVO?.cell !== 0">发表Cell{{ paperData.paperLeadAndVenueVO?.cell }}篇；</span>
        </span>
      </div>
      <div class="selectType flex items-center flex-wrap">
        <el-select
          v-if="paperYearOptions && paperYearOptions.length"
          popper-class="advanced-select"
          v-model="paperYear"
          placeholder="年份"
          size="mini"
          @change="paperYearChange"
          multiple
          clearable
          collapse-tags
        >
          <el-option
            v-for="(item, index) in paperYearOptions"
            :key="index"
            :label="`${item.year} (${item.yearCount})`"
            :value="item.year"
          ></el-option>
        </el-select>
        <el-select
          v-if="paperFieldsOptions && paperFieldsOptions.length"
          style="margin-left: 20px"
          popper-class="advanced-select"
          v-model="paperField"
          placeholder="主题筛选"
          size="mini"
          @change="paperFieldChange"
          multiple
          clearable
          collapse-tags
        >
          <el-option
            v-for="(item, index) in paperFieldsOptions"
            :key="index"
            :label="`${item.name} (${item.count})`"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-if="paperJourOptions && paperJourOptions.length"
          style="margin-left: 20px"
          popper-class="advanced-select"
          v-model="paperJour"
          placeholder="核心期刊"
          size="mini"
          @change="paperJourChange"
          multiple
          clearable
          collapse-tags
        >
          <el-option
            v-for="(item, index) in paperJourOptions"
            :key="index"
            :label="`${item.paperType} (${item.paperTypeCount})`"
            :value="item.paperType"
          ></el-option>
        </el-select>
        <el-select
          v-if="paperJcrOptions && paperJcrOptions.length"
          style="margin-left: 20px"
          popper-class="advanced-select"
          v-model="paperJcr"
          placeholder="JCR分区"
          size="mini"
          @change="paperJcrChange"
          multiple
          clearable
          collapse-tags
        >
          <el-option
            v-for="(item, index) in paperJcrOptions"
            :key="index"
            :label="`${item.JcrArea || item.jcrArea} (${item.jcrAreaCount || item.JcrAreaCount})`"
            :value="item.JcrArea || item.jcrArea"
          ></el-option>
        </el-select>
        <el-checkbox v-model="paperSort" @change="paperSortChange" style="margin-left: 20px">引用量排序</el-checkbox>
        <el-checkbox v-model="firstAuthor" @change="lookFirstAuthorPaper">只看一作论文</el-checkbox>
      </div>
      <div class="text-left item-bottom" v-for="(item, index) in paperData.paperList" :key="index">
        <achievement-item ach-type="论文" :ach-data="item" />
      </div>
      <div class="page-container" v-if="paperData.paperList && paperData.paperList.length">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="achParams.pageNo + 1"
          :page-size="achParams.pageSize"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          layout="sizes,prev, pager, next"
          :total="paperData.paperElements"
        />
      </div>
      <el-empty v-else />
    </div>
    <div v-if="achType === '专利'" v-loading="patentLoading" style="min-height: 400px">
      <div class="selectType">
        <el-select
          popper-class="advanced-select"
          v-model="patentYear"
          placeholder="申请年份"
          size="mini"
          @change="yearChange"
          multiple
          clearable
          collapse-tags
        >
          <el-option
            v-for="(item, index) in patentYearOptions"
            :key="index"
            :label="`${item.year} (${item.yearCount})`"
            :value="item.year"
          ></el-option>
        </el-select>

        <el-select
          style="margin-left: 20px"
          popper-class="advanced-select"
          v-model="patentType"
          placeholder="专利类型"
          size="mini"
          @change="patentTypeChange"
          multiple
          clearable
          collapse-tags
        >
          <el-option
            v-for="(item, index) in patentTypeOptions"
            :key="index"
            :label="`${item.patentType} (${item.patentTypeCount})`"
            :value="item.patentType"
          ></el-option>
        </el-select>
      </div>
      <div
        class="text-left item-bottom"
        v-for="(item, index) in patentData.patentList"
        :key="index"
      >
        <achievement-item ach-type="专利" :ach-data="item" />
      </div>
      <div class="page-container" v-if="patentData.patentList && patentData.patentList.length">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="achParams.pageNo + 1"
          :page-size="achParams.pageSize"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          layout="sizes,prev, pager, next"
          :total="patentData.patentElements"
        />
      </div>
      <el-empty v-else />
    </div>
    <div v-if="achType === '项目'" v-loading="projectLoading" style="min-height: 400px;margin-top: -10px">
      <div v-if="projectData.projectList && projectData.projectList.length">
        <div
          class="project-item"
          v-for="project in projectData.projectList"
          :key="project.id"
        >
          <achievement-item ach-type="项目" :ach-data="project" />
        </div>
      </div>
      <div class="page-container"
           v-if="projectData.projectList && projectData.projectList.length">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="achParams.pageNo + 1"
          :page-size="achParams.pageSize"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          layout="sizes,prev, pager, next"
          :total="projectData.projectElements"
        />
      </div>

      <el-empty v-else />
    </div>
  </div>
</template>

<script>
import {
  postFindPaperListApi,
  postFindPatentListApi,
  getScholarProjectsApi,
} from '@/api/details';
import AchievementItem from '@/views/details/comps/achievementItem.vue';
import { postPaperConditionApi, postPatentConditionApi } from '@/api/achievement';

export default {
  name: 'achievementList',
  components: { AchievementItem },
  props: ['scholarId'],
  data() {
    return {
      paperLoading: false,
      patentLoading: false,
      projectLoading: false,
      achType: '论文',
      totalElements: 0,
      achParams: {
        pageNo: 0,
        pageSize: 10,
      },
      paperData: {
        paperElements: 0,
        paperAuthor: 0,
        paperList: [],
        paperLeadAndVenueVO: {},
      },
      paperYearOptions: [],   // 论文年份options
      paperYear: [],          // 论文年份
      paperSortOptions: [     // 排序
        {value: '全部', label: '全部'},
        {value: '引用量', label: '引用量'},
      ],
      paperSort: false,       // 引用量排序
      firstAuthor: false,     // 只看一作论文
      paperFieldsOptions: [], // 主题筛选Options
      paperField: [],         // 主题筛选值
      paperJourOptions: [],   // 核心期刊Options
      paperJour: [],          // 核心期刊值
      paperJcrOptions: [],    // JCR分区Options
      paperJcr: [],           // JCR分区值


      patentData: {
        patentElements: 0,
        patentList: [],
      },
      patentYear: [],        // 专利年份值
      patentYearOptions: [], // 专利年份Options
      patentType: [],        // 专利类型值
      patentTypeOptions: [], // 专利类型Options
      projectData: {
        projectElements: 0,
        projectList: [],
      },
    };
  },
  created() {
    this.getPaperData();
    this.getPatentData();
    this.getProjectData();
    this.getPaperConditionData();
    this.getPatentConditionData();
  },
  methods: {
    // 获取论文筛选条件
    getPaperConditionData() {
      let param = {
        talentId: this.scholarId,
        talentLocationType: isNaN(this.scholarId) ? '国外人才': '国内人才',
        fieldId: this.paperField || [] ,       // 技术领域
        type: this.paperSort ? '引用数' : null, // 排序
        yearList: this.paperYear || [],        // 年份
        jcrPartitionList: this.paperJcr|| [],  // jcr分区
        jourConsList: this.paperJour || [],    // 核心期刊
        contentsList: this.AList || [],    // A类
        page: this.achParams.pageNo,
        size: this.achParams.pageSize,
        firstAuthor: this.firstAuthor,         // 第一作者
      };

      postPaperConditionApi(param).then((res) => {
        if (res.code === 200) {
          // 技术领域
          this.paperFieldsOptions = res.data.fieldList?.filter(item => item.name !== '全部') || [];
          // 年份
          this.paperYearOptions = res.data.yearList?.filter(item => item.year !== '全部') || [];
          // JCR分区
          this.paperJcrOptions = res.data.JcrAreaList?.filter(item => item.jcrArea !== '全部') || [];
          // 核心期刊
          if (isNaN(this.scholarId)){
            this.paperJourOptions = res.data.journalList?.filter(item => item.paperType !== '全部') || [];
          } else {
            this.paperJourOptions = res.data.journalList?.filter(item => item.paperType !== '全部') || [];
          }

        }
      }).finally(() => {
        this.paperConditLoading = false;
      });
    },

    // 只看一作论文
    lookFirstAuthorPaper() {
      this.getPaperData();
    },
    paperSortChange(){
      this.achParams.pageNo = 0;
      this.getPaperData()
    },
    // JCR分区切换
    paperJcrChange(val){
      this.achParams.pageNo = 0;
      if (val[0] === '全部'){
        this.paperJcr = [];
      }else {
        this.paperJcr = val;
      }
      this.getPaperData();
    },

    // 核心期刊切换
    paperJourChange(val){
      this.achParams.pageNo = 0;
      this.paperJour = val;
      this.getPaperData();
    },
    // 论文领域（主题）筛选
    paperFieldChange(val){
      this.achParams.pageNo = 0;
      this.paperField = val;
      this.getPaperData();
    },

    // 论文年份筛选
    paperYearChange(val){
      this.achParams.pageNo = 0;
      this.paperYear = val;
      this.getPaperData();
    },

    // 专利年份筛选
    yearChange(val){
      this.achParams.pageNo = 0;
      this.patentYear = val;
      // 值变化重新调用数据和筛选条件
      this.getPatentData();
      this.getPatentConditionData()
    },

    // 专利类型切换
    patentTypeChange(val){
      this.achParams.pageNo = 0;
      this.patentType = val;
      // 值变化重新调用数据和筛选条件
      this.getPatentData();
      this.getPatentConditionData()
    },

    // 获取筛选条件
    getPatentConditionData() {
      let params = {
        talentLocationType:isNaN(this.scholarId)?'国外人才':'国内人才',
        talentId: this.scholarId,
        patentTypes: this.patentType,
        years: this.patentYear,
      }
      postPatentConditionApi(params).then((res) => {
        if (res.code === 200) {
          this.patentYearOptions = res.data.year?.filter(item => item.year !== '全部');
          this.patentTypeOptions = res.data.patentType?.filter(item => item.patentType !== '外观设计').filter(item => item.patentType !== '全部');
        }
      });
    },

    // goPersonalDetails(id) {
    //   if (id) {
    //     let obj = {
    //       name: 'talentDetails',
    //       query: {
    //         id: id,
    //         isBack: '1',
    //         backName: this.backName,
    //       },
    //     };
    //     let routeData = this.$router.resolve(obj);
    //     window.open(routeData.href, '_blank');
    //   } else {
    //     this.$message.warning({
    //       message: '暂无详情数据',
    //       type: 'warning',
    //     });
    //   }
    // },
    toDetail(id, path) {
      if (id) {
        this.$router.push({
          path: path,
          query: { id: id, isBack: '1', backName: this.backName },
        });
      } else {
        this.$message.warning({
          message: '无详情数据',
          type: 'warning',
        });
      }
    },
    /**
     * 跳转至详情页面
     */
    goDetails(path, id) {
      this.$router.push({ path: path, query: { id: id } });
    },
    /**
     * 获取专利列表
     */
    getProjectData() {
      this.projectLoading = true;
      getScholarProjectsApi(this.scholarId, this.achParams)
        .then((res) => {
          if (res.code == 200) {
            this.projectData.projectList = res.data.content;
            this.projectData.projectElements = res.data.totalElements;
          }
          this.projectLoading = false;
        })
        .catch(() => {
          this.projectLoading = false;
        });
    },
    /**
     * 获取专利列表
     */
    getPatentData() {
      this.patentLoading = true;
      let param = {
        page: this.achParams.pageNo,
        size: this.achParams.pageSize,
        talentId:this.scholarId,
        talentLocationType:isNaN(this.scholarId)?'国外人才':'国内人才',
        patentTypes: this.patentType,
        years: this.patentYear,
      };
      postFindPatentListApi(param)
        .then((res) => {
          if (res.code == 200) {
            this.patentData.patentList = res.data.content;
            this.patentData.patentElements = res.data.totalElements;
          }
          this.patentLoading = false;
        })
        .catch(() => {
          this.patentLoading = false;
        });
    },
    /**
     * 获取论文列表
     */
    getPaperData() {
      this.paperLoading = true;
      let param = {
        talentId: this.scholarId,
        talentLocationType: isNaN(this.scholarId) ? '国外人才': '国内人才',
        fieldId: this.paperField || [] ,       // 技术领域
        type: this.paperSort ? '引用数' : null, // 排序
        yearList: this.paperYear || [],        // 年份
        jcrPartitionList: this.paperJcr|| [],  // jcr分区
        jourConsList: this.paperJour || [],    // 核心期刊
        page: this.achParams.pageNo,
        size: this.achParams.pageSize,
        firstAuthor: this.firstAuthor,         // 第一作者
      };
      postFindPaperListApi(param)
        .then((res) => {
          if (res.code == 200) {
            res.data.data.map((item) => {
              if (item.authorList){
                if (item.authorList.length > 4) {
                  item.authorList = item.authorList.slice(0, 4);
                }
              }else {
                item.authorList = item.authors;
              }

            });
            this.paperData.paperList = res.data.data;
            this.paperData.paperElements = res.data.total;
            this.paperData.paperAuthor = res.data.leadAuthorPubSum;
            this.paperData.paperLeadAndVenueVO = res.data.paperLeadAndVenueVO;
          }
          this.paperLoading = false;
        })
        .catch(() => {
          this.paperLoading = false;
        });
    },

    /**
     * 修改展示的成果类型
     * 成果类型
     * @param type
     */
    changeAchType(type) {
      this.achType = type;
      this.achParams.pageNo = 0;
      if (this.achType === '论文') {
        this.getPaperData();
      } else if (this.achType === '专利') {
        this.getPatentData();
      } else if (this.achType === '项目') {
        this.getProjectData();
      }
    },
    /**
     * 修改页数
     * 点击的页数 后台从0开始,所以赋值时-1
     * @param val
     */
    handleCurrentChange(val) {
      this.achParams.pageNo = val - 1;
      if (this.achType === '论文') {
        this.getPaperData();
      } else if (this.achType === '专利') {
        this.getPatentData();
      } else if (this.achType === '项目') {
        this.getProjectData();
      }
    },
    /**
     * 修改单页请求数量
     * 数量
     * @param val
     */
    handleSizeChange(val) {
      this.achParams.pageSize = val;
      if (this.achType === '论文') {
        this.getPaperData();
      } else if (this.achType === '专利') {
        this.getPatentData();
      } else if (this.achType === '项目') {
        this.getProjectData();
      }
    },
  },
};
</script>

<style scoped>
.achievementTitle {
  font-size: 14px;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  cursor: pointer;
  border-radius: 14px;
  margin-right: 14px;
}

.selectAchievementTitle {
  font-size: 14px;
  color: #1241C9;
  cursor: pointer;
  display: flex;
  margin-right: 14px;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  border-radius: 14px;
}

.achLine {
  color: #666666;
  margin-right: 22px;
  font-size: 13px;
  margin-top: 10px;

  span {
    color: #999999;
  }
}

.item-bottom {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 12px;
  margin-bottom: 15px;
}

.achTitle {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.achievement-item {
  padding: 8px 0;

  &:not(:last-child) {
    border-bottom: 1px dashed #e8eaee;
  }

  .title {
    max-width: 1100px;
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      font-size: 16px;
      color: #101828;
      cursor: pointer;
      letter-spacing: 0.5px;

      &:hover {
        color: #1241C9;
      }
    }
  }

  .info {
    display: flex;
    align-items: center;
    margin-top: 6px;
    flex-wrap: wrap;

    li {
      display: flex;
      align-items: center;
      margin-right: 30px;
      //margin-bottom: 6px;

      > span {
        color: #667085;
        font-size: 14px;
      }

      > p {
        font-size: 14px;
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #101828;
      }
    }

    li.inventor {
      p {
        margin-right: 10px;
        display: flex;
        align-items: center;

        span {
          color: #101828;
          font-size: 14px;
          margin-left: 5px;
        }
      }
    }
  }
}

.project-item {
  .info {
    .inventor {
      p {
        span {
          color: #101828 !important;
        }
      }
    }
  }
}

.selectType {
  display: flex;
  margin-bottom: 10px;

  /deep/ .el-loading-spinner .circular {
    width: 25px;
    height: 25px;
  }
}

.title {
  max-width: 1100px;
  text-align: start;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  span {
    font-size: 16px;
    color: #101828;
    cursor: pointer;
    letter-spacing: 0.5px;

    &:hover {
      color: #1241C9;
    }
  }
}
</style>
